<template>
	<div class="content">
		<div class="content_head">
			<input type="text" @keypress.enter="pageIndex=1;getData()" placeholder="书籍条码|书籍编码|书籍名称|作者名称" class="search"
				v-model="search" />
			<button type="button" class="button " @click="pageIndex=1;getData()">查找</button>
			<button type="button" class="button add" @click="Edit='add'">+新书归档</button>
		</div>
		<div class="content_body">
			<table>
				<thead>
					<tr>
						<th>序号</th>
						<th>书籍信息</th>
						<th>简介</th>
						<th>编辑</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(i,index) in books">
						<td>
							{{index+1+ (pageIndex-1)*pageRows}}
						</td>
						<td>
							<div class="bookBaseInfor">
								<div>
									书籍名称:
								</div>
								<div>
									{{i.BooksName}}
								</div>
								<div>
									书籍作者:
								</div>
								<div>
									{{i.WriterName + ' '+ WriterBooksReferences}}
								</div>

								<div>
									书籍分类:
								</div>
								<div>
									{{i.Classification1}}
								</div>
								<div>
									书籍图片:
								</div>
								<div class="red">
									{{i.imgCount+'张'}}
								</div>
								<div>
									书籍状态:
								</div>

								<div>
									{{i.BooksSate==0?'正常':'已下架'}}
								</div>

							</div>

						</td>
						<td>
							<div class="bookInfor">
								<div>
									书籍简介:
								</div>
								<div>
									{{i.BookBriefIntroduction}}
								</div>
							</div>

						</td>

						<td>
							<button type="button" class="button" @click='updateBooks(i)'>
								编辑信息
							</button><br />
							<button type="button" class="button"
								@click="$router.replace('/bookMangmentImage/'+i.BooksID)">
								书籍图片
							</button><br />

						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="foot_pages">
			当前种类:<span class="red"> {{count+"种"}}</span>
			<button class="button" :class="{'disabled':up}" :disabled="up" @click="changePages('up')">上一页</button>
			<span>{{page}}</span>

			<select v-model="pageRows" @change="changePageRows">
				<option value="10">10/页</option>
				<option value="20">20/页</option>
				<option value="30">30/页</option>

			</select>
			<button class="button" :class="{'disabled':down}" :disabled="down" @click="changePages('down')">下一页</button>
		</div>
		<div class="booksMangement" v-show="Edit!=''">
			<div>
				<div>
					<span class="red">*</span>书籍名称:
				</div>
				<div>
					<input type="text" v-model="BooksName" placeholder="请输入书籍名称" />
					<span class="err">{{BooksName.length>0?' ':'×'}}</span>
				</div>

				<div>
					<span class="red">*</span>书籍作者:
				</div>
				<div>


					<input type="text" v-model="WriterName" placeholder="请输入作者" :readonly="WriterID!=1" />

					<span class="err">{{WriterName.length>0?' ':'×'}}</span>

				</div>

				<div>
					<span class="red">&nbsp;</span>选择作者:
				</div>

				<div>
					<label>

						<select v-model="WriterID" @change="selectWriter">
							<option v-for="(i,index) in $store.state.Writer" :value="i.WriterID">{{i.WriterName}}
							</option>
						</select>

					</label>

				</div>

				<div>
					<span class="red">&nbsp;</span>设置关系:
				</div>

				<div>

					<label v-for="i in  WriterBooksReferencesType">
						<input type="radio" :checked="i==WriterBooksReferences" name="WriterBooksReferences" :value="i"
							@change="WriterBooksReferences=i" />{{i}}
					</label>

				</div>

				<div>
					<span class="red">*</span>推荐理由:
				</div>
				<div>
					<label>

						<input type="text" v-model="RecommendReason" placeholder="上架原因" />
						<span class="err">{{RecommendReason.length>0?' ':'×'}}</span>
					</label>
				</div>

				<div>
					<span class="red">*</span>选择归属:
				</div>
				<div>
					<label>

						<select v-model="ClassificationID">
							<option v-for="(i,index) in $store.state.Classification" :value="i.ClassificationID">
								{{i.Classification1}}
							</option>
						</select>
						<span class="err">{{ClassificationID>0?' ':'×'}}</span>
					</label>
				</div>

				<div>
					<span class="red">*</span>显示权重:
				</div>
				<div>
					<label>

						<input type="text" v-model="virtualCount" placeholder="显示权重" />
						<span class="err"></span>
					</label>
				</div>


				<div>
					<span class="red">&nbsp;</span>一级分类:
				</div>
				<div>
					<label v-for="(i,index) in $store.state.CategoryMenu">

						<!-- <select v-model="ClassificationID" @change="selectWriter">
							<option v-for="(i,index) in $store.state.CategoryMenu" :value="i.CategoryCode">{{i.CategoryMenuName}}</option>
						</select> -->

						<span>
							<input type="checkbox" name="CategoryMenu" :value="i.CategoryMenuName"
								v-model="CategoryMenuName" />
							<button type="button" class="buttonSamll"
								@click="selectOne(i)">{{i.CategoryMenuName}}</button>
						</span>

					</label> <span class="err">{{CategoryMenuName.length>0?' ':'×'}}</span>
				</div>

				<div>
					<span class="red">&nbsp;</span>二级分类:
				</div>
				<div>
					<label v-for="(i,index) in CategoryMenu_2">

						<!-- <select v-model="ClassificationID" @change="selectWriter">
							<option v-for="(i,index) in $store.state.CategoryMenu" :value="i.CategoryCode">{{i.CategoryMenuName}}</option>
						</select> -->

						<span>
							<input type="checkbox" name="CategoryMenu" :value="i.CategoryMenuName"
								v-model="CategoryAttribute" />
							<button type="button" :class="{'add':i.ChildrenMenu.length>0}" class="buttonSamll"
								@click="selectTwo(i)">{{i.CategoryMenuName}}</button>
						</span>

					</label>
					<span class="err">{{CategoryAttribute.length>2?' ':'×'}}</span>
				</div>

				<div v-show="CategoryMenu_3.length>0">
					<span class="red">&nbsp;</span>三级分类:
				</div>
				<div v-show="CategoryMenu_3.length>0">


					<!-- <select v-model="ClassificationID" @change="selectWriter">
							<option v-for="(i,index) in $store.state.CategoryMenu" :value="i.CategoryCode">{{i.CategoryMenuName}}</option>
						</select> -->
					<label v-for="(i,index) in CategoryMenu_3">
						<span>
							<input type="checkbox" name="CategoryMenu" :value="i.CategoryMenuName"
								v-model="CategoryAttribute" />
							<button type="button" class="buttonSamll">{{i.CategoryMenuName}}</button>
						</span>
					</label>
					<span class="err">{{CategoryAttribute.length>2?' ':'×'}}</span>

				</div>

				<div>
					<span class="red"></span>自定义类别:
				</div>
				<div>
					<label>

						<input type="text" v-model="CustomCategory" placeholder="请输入自定义类别" />

						&nbsp;&nbsp;
						<button type="button" @click="addCustomCategory" class="buttonSamll">添加</button>
						<p style="padding-top: .3rem;">
							<button class="buttonSamll" title="点击移除" v-for="(i,index) in customCategory" type="button"
								@click="customCategory.splice(index,1)">{{i}}
							</button>
						</p>

					</label>
				</div>


				<div>
					<span class="red">*</span>书籍标签:
				</div>
				<div>
					<label>

						<input type="text" v-model="tagText" placeholder="请输入书籍标签" />
						<span class="err">{{Tag.length>0?' ':'×'}}</span>
						&nbsp;&nbsp;
						<button type="button" @click="addTag" class="buttonSamll">添加</button>
						<p style="padding-top: .3rem;">
							<button class="buttonSamll" title="点击移除" v-for="(i,index) in Tag" type="button"
								@click="Tag.splice(index,1)">{{i}}
							</button>
						</p>

					</label>
				</div>

				<div>
					<span class="red">*</span>归属系列:
				</div>
				<div>
					<label>
						<input type="text" v-model="BelongTo" placeholder="书籍的归属系列" />
						<span class="err">{{BelongTo.length>0?' ':'×'}}</span>
					</label>
				</div>


				<div>
					<span class="red">*</span>书籍简介:
				</div>
				<div>
					<label>

						<textarea v-model="BookBriefIntroduction" placeholder="请输入书籍简介" class="booksTextArea">


						</textarea>
						<span class="err">{{BookBriefIntroduction.trim().length>0?' ':'×'}}</span>
					</label>
				</div>

				<div>
					<span class="red">*</span>编辑寄语:
				</div>
				<div>
					<label>

						<textarea v-model="BookRecommend" placeholder="编辑推荐寄语" class="booksTextArea">


						</textarea>
						<span class="err">{{BookRecommend.trim().length>0?' ':'×'}}</span>
					</label>
				</div>

				<div>
					<span class="red">&nbsp;</span>书籍状态:
				</div>
				<div>
					<label>

						<select v-model="BooksSate">
							<option value="0">正常</option>
							<option value="1">下架</option>
						</select>

					</label>
				</div>

				<div>
					<span class="red">&nbsp;</span>书籍备注:
				</div>
				<div>
					<label>

						<textarea v-model="BooksDesc" placeholder="书籍变动备注" class="booksTextArea">


						</textarea>

					</label>
				</div>

				<div>

				</div>
				<div style="text-align: center;padding-top: 1rem;">

					<button class="button" :class="{'disabled':!checkbook}" :disabled="!checkbook" @click="editUsers"
						style="margin-right: 10rem;">{{Edit=='add'? '添加':'修改'}}</button>
					<button class="button" @click="cancel">取消</button>

				</div>

			</div>


		</div>



	</div>
</template>

<script>
	export default {
		name: 'bookMangment',
		data() {
			return {
				search: '',
				BooksID: 0,
				BooksName: '',
				BookBriefIntroduction: '',
				BookRecommend: '',
				WriterName: '',
				WriterID: 1,
				RecommendReason: '',
				WriterBooksReferences: '著',
				BorrowCount: '',
				BooksSate: 0,
				BooksDesc: '',
				Tag: [],
				BelongTo: '',
				CategoryMenuName: [],
				CategoryAttribute: [],
				ClassificationID: this.$store.state.Classification[0].ClassificationID,
				OperatorID: this.$store.state.user.UserID,
				CategoryMenu_2: this.$store.state.CategoryMenu[0].ChildrenMenu,
				CategoryMenu_3: [],
				tagText: '',
				CustomCategory: '',
				WriterBooksReferencesType: ['著', '编', '译'],
				virtualCount: 0,
				customCategory: [],

				books: [],

				Edit: '',
				getData: {},
				clear: {},


				pageIndex: 1,
				pageRows: 10,
				count: 0
			};
		},
		created() {

			this.getData = function() {
				this.$request.request({
					url: 'books/getBooksBySearch',
					data: {
						pageCount: this.pageRows,
						pageIndex: this.pageIndex,
						searchText: this.search
					},
					method: 'post'
				}).then(res => {
					if (res.result) {
						this.books = res.books;
						this.count = res.count;
					}
				});
			}
			this.clear = function() {
				this.virtualCount = 0;
				this.BooksID = 0;
				this.BooksName = '';
				this.BookBriefIntroduction = '';
				this.BookRecommend = '';
				this.WriterName = '';
				this.WriterID = 1;
				this.RecommendReason = '';
				this.WriterBooksReferences = '著';
				this.BorrowCount = '';
				this.BooksSate = 0;
				this.BooksDesc = '';
				this.Tag = [];
				this.customCategory = [];
				this.CustomCategory = "";
				this.BelongTo = '';
				this.CategoryMenuName = [];
				this.CategoryAttribute = [];
				this.ClassificationID = this.$store.state.Classification[0].ClassificationID;
				this.OperatorID = this.$store.state.user.UserID;
				this.CategoryMenu_2 = this.$store.state.CategoryMenu[0].ChildrenMenu;
				this.CategoryMenu_3 = [];
				this.tagText = '';
				this.WriterBooksReferencesType = ['著', '编', '译'];
			}
			this.$store.dispatch('refresh');
			this.getData();

		},
		methods: {
			searchBooks(e) {
				if (e.keyCode == 13)
					this.getData();;
			},
			addCustomCategory() {
				if (this.CustomCategory == "") return;
				this.customCategory.push(this.CustomCategory);

				this.CustomCategory = '';
			},
			addTag() {
				if (this.tagText == "") return;
				this.Tag.push(this.tagText);
				this.tagText = '';
			},
			selectOne(i) {
				this.CategoryID == i.CategoryMenuID
				this.CategoryMenu_2 = i.ChildrenMenu;
				this.CategoryMenu_3 = [];
			},
			selectTwo(i) {
				this.CategoryMenu_3 = i.ChildrenMenu;
			},
			selectWriter() {
				if (this.WriterID == 1) {
					this.WriterName = '';
					return;
				}
				for (let i of this.$store.state.Writer) {
					if (i.WriterID == this.WriterID) {
						this.WriterName = i.WriterName;
						return;
					}
				}
			},
			cancel() {
				this.Edit = '';
				this.clear();
			},
			editUsers() {
				this.Edit = '';


				this.$request.request({
					url: 'books/editBooks',
					data: {
						BooksID: this.BooksID,
						BooksName: this.BooksName,
						BookBriefIntroduction: this.BookBriefIntroduction,
						BookRecommend: this.BookRecommend,
						WriterName: this.WriterName,
						WriterID: this.WriterID,
						RecommendReason: this.RecommendReason,
						Tag: this.Tag.toString(),
						WriterBooksReferences: this.WriterBooksReferences,
						CategoryMenuName: this.CategoryMenuName.toString(),
						CategoryAttribute: this.CategoryAttribute
							.toString(), //this.customCategory.length > 0 ? this.CategoryAttribute.concat(this.customCategory).toString() :
						CustomCategory: this.customCategory.toString(),
						ClassificationID: this.ClassificationID,
						BooksDesc: this.BooksDesc,
						BelongTo: this.BelongTo,
						BooksSate: this.BooksSate,
						OperatorID: this.$store.state.user.UserID,
						virtualCount: this.virtualCount
					},
					method: 'post'
				}).then(res => {
					if (res.result) {
						this.$uil.showMessage({
							text: res.message
						});
						this.clear();
						this.getData();
					}
				});
			},
			updateBooks(i) {
				this.BooksID = i.BooksID;
				this.Edit = 'update';
				this.WriterID = i.WriterID;
				this.WriterName = i.WriterName;
				this.BooksName = i.BooksName;
				this.BookBriefIntroduction = i.BookBriefIntroduction;
				this.RecommendReason = i.RecommendReason;
				this.BookRecommend = i.BookRecommend;
				this.WriterID = i.WriterID;
				this.WriterBooksReferences = i.WriterBooksReferences;
				this.BooksSate = i.BooksSate;
				this.ClassificationID = i.ClassificationID;

				this.virtualCount = i.virtualCount;
				this.BelongTo = i.BelongTo;
				this.CategoryMenuName = i.CategoryMenuName == "" || i.CategoryMenuName == null ? [] : i
					.CategoryMenuName.split(',');

				this.CategoryAttribute = i.CategoryAttribute == "" || i.CategoryAttribute == null ? [] : i
					.CategoryAttribute.split(',');
				this.customCategory = i.CustomCategory == "" || i.CustomCategory == null ? [] : i.CustomCategory.split(
					',');
				this.Tag = i.Tag.split(',');


			},
			changePages(s) {
				if (s == 'up') {
					if (this.pageIndex == 1)
						return;
					else
						this.pageIndex--;

				} else {
					if (this.pageIndex * this.pageRows >= this.count)
						return;
					else
						this.pageIndex++;
				}

				this.getData();
			},
			changePageRows() {
				if (this.pageIndex * this.pageRows >= this.count)
					this.pageIndex = 1;
				this.getData();
			}
		},
		computed: {
			checkbook() {
				return this.BooksName.trim().length > 0 && this.BookBriefIntroduction.trim().length > 0 && this.WriterName
					.trim().length > 0 &&
					this.ClassificationID >
					0 && this.RecommendReason.trim().length > 0 && this.BookRecommend.trim().length > 0 && this.Tag
					.length > 0 && this
					.CategoryAttribute.length > 0 && this.CategoryMenuName.length > 0;
			},
			up() {
				if (this.pageIndex == 1)
					return true;
				else
					return false;
			},
			down() {
				if (this.pageIndex * this.pageRows >= this.count)
					return true;
				else
					return false;
			},
			page() {
				if (Math.ceil((this.count / this.pageRows)) == 0)
					return this.pageIndex + '/' + 1 + '页';
				else
					return this.pageIndex + '/' + Math.ceil((this.count / this.pageRows)) + '页';
			}
		},
		filters: {

		},
		activated() {
			this.getData();
		}

	}
</script>

<style>
	.bookInfor {
		grid-template-columns: 5rem 1fr;
	}

	.bookBaseInfor {
		grid-template-columns: 5rem 15rem;
	}

	.bookInfor,
	.bookBaseInfor {
		display: grid;

		grid-gap: .2rem;
		line-height: 1.5rem;
		justify-content: center;
	}

	.bookInfor div:nth-child(even),
	.bookBaseInfor div:nth-child(even) {
		text-align: left;
		white-space: normal;
		word-break: break-all;
		overflow: hidden;
	}
</style>
